export default {
    users: [],
    filters: [],
    statement: {
        user: null,
    }
};
